import React from "react";

//создаем объект контекста и экспортируем его
export const CurrentUserContext = React.createContext();